import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Progress } from 'next-common-lib';

export const Loading = () => {
  const loading = useSelector(state => state.loading);

  return (
    loading.isShow && (
      <Modal isDimed dimedClassName="has-bg">
        <div style={{ width: 100 }}>
          <Progress componentType="loading" />
        </div>
      </Modal>
    )
  );
};
Loading.propTypes = {};
Loading.defaultProps = {};
export default Loading;
